<mat-card>
  <mat-card-header>    
      <mat-card-title class="popupHeader">
        <div class="mat-card-header-text" i18n>
          Redlining Presets
        </div>       
      </mat-card-title> 
      <button mat-icon-button i18n-matTooltip matTooltip="Delete" [disabled]="!actionCode" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
      </button>      
      <button mat-icon-button i18n-matTooltip matTooltip="Add new" tabindex="-1" (click)="onReset()">
        <mat-icon>add</mat-icon>
      </button>     
  </mat-card-header>

  <mat-card-content>
    <div class="mainCard">
      <mat-card class="listView">
        <div class="listViewCard">
          <mat-list>  
            <mat-list-item *ngFor="let preset of presetOptions" [value]="preset" [class.selected]="sPreset === preset" (click)="selectedPreset(preset)" >
              <button class="leftIcon" mat-icon-button [style.visibility]="sPreset === preset ? 'visible':'hidden'">
                <mat-icon class="iconTyp">task_alt</mat-icon>
              </button>
              <p matListItemTitle class="listItem">{{preset.header}}</p>
            </mat-list-item>
        </mat-list>  
        </div>
      </mat-card>
      <div class="presetForm">
        <form>
          <mat-form-field class="my-form-field">           
            <input name="header" placeholder= {{splaceholder}} matInput [(ngModel)]="header">
          </mat-form-field>
          <mat-form-field class="my-form-field" style="margin-top: 20px;">            
            <textarea class="presetTextArea" placeholder={{cplaceholder}} name="content" matInput [(ngModel)]="content" ></textarea>
          </mat-form-field>
        </form>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <div class="buttonContent">      
      <button mat-raised-button type="button" color="primary" (click)="onSave()">{{buttontext}}</button>
    </div>    
  </mat-card-actions>

</mat-card>
